module.exports = "img/photo16.df09c5.jpeg";